import apiClient from './apiClient'

export const getCustomerRoles = async (params = {}) => {
  const response = await apiClient.get('/auth/customer-roles/', { params })
  return response.data
}

export const createCustomerRole = async (data) => {
  const response = await apiClient.post('/auth/customer-roles/', data)
  return response.data
}

export const updateCustomerRole = async (id, data) => {
  const response = await apiClient.patch(`/auth/customer-roles/${id}/`, data)
  return response.data
}

export const deleteCustomerRole = async (id) => {
  await apiClient.delete(`/auth/customer-roles/${id}/`)
}

export const getInvitationCodes = async (params = {}) => {
  const response = await apiClient.get('/auth/invitation-codes/', { params })
  return response.data
}

export const createInvitationCode = async (data) => {
  const response = await apiClient.post('/auth/invitation-codes/', data)
  return response.data
}

export const updateInvitationCode = async (id, data) => {
  const response = await apiClient.patch(`/auth/invitation-codes/${id}/`, data)
  return response.data
}

export const deleteInvitationCode = async (id) => {
  await apiClient.delete(`/auth/invitation-codes/${id}/`)
}

export const activateInvitationCode = async (id) => {
  const response = await apiClient.post(`/auth/invitation-codes/${id}/activate/`)
  return response.data
}

export const deactivateInvitationCode = async (id) => {
  const response = await apiClient.post(`/auth/invitation-codes/${id}/deactivate/`)
  return response.data
}

export const validateInvitationCode = async (code) => {
  const response = await apiClient.post('/auth/validate-invitation/', { code: code.trim() })
  return response.data
}

export const getInvitationStats = async () => {
  const response = await apiClient.get('/auth/invitation-stats/')
  return response.data
}

export const slugifyRole = (label) => {
  return (label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}
